import { render, staticRenderFns } from "./AccreditationDetail.vue?vue&type=template&id=12521024&"
import script from "./AccreditationDetail.ts?vue&type=script&lang=ts&"
export * from "./AccreditationDetail.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports